import { gql } from '@apollo/client'

export const GET_LESSON_EXTRA_CONTENTS = gql`
  query getLessonExtraContents(
    $id: ID!
    $offset: Int!
    $limit: Int!
    $ordenation: OrdenationInputObject!
  ) {
    course(id: $id) {
      id
      lessons(
        withExtraMedia: true
        ordenation: $ordenation
        pagination: { offset: $offset, limit: $limit }
      ) {
        nodes {
          available
          id
          title
          releaseAt
          releaseAfter
          courseClassReleaseOffset
          lockAt
          lockAfter
          courseContentId
          activity {
            id
            examQuestionsCount
          }
          media {
            id
            type
            duration
            hostKey
            host
            originUrl
            providerKey
            fileExt
            text
            organizationUuid
          }
          extraMediaReleases {
            mediaId
            releaseAt
            releaseAfter
            lockAt
            lockAfter
          }
          extraMedias {
            title
            id
            type
            fileExt
            text
            host
            hostKey
            originUrl
            providerKey
            organizationUuid
          }
        }
      }
    }
  }
`
